export class StringUtil {
    static isNullOrEmpty(s?: string | null): boolean {
        return s == null || s.trim() === ''
    }

    static hasContent(s?: string | null): s is string {
        return !this.isNullOrEmpty(s)
    }
}
